import React, { useState, useEffect } from "react";
import ModalAddInterview from "./ModalAddInterview";
import { Form } from "antd";
import { url_get_list_district } from "../../../../constants";
import Cookies from "universal-cookie";
import { authAxios } from "../../../../utils";
import moment from "moment";

const cookies = new Cookies();

const index = ({
  isModalAddInterview,
  setIsModalAddInterview,
  dateTimeSelect,
  typeModal,
  onFinishAddInterview,
  onFinishDelete,
  onFinishEdit,
  listUser,
  handleViewCVInterview,
}) => {
  const [form] = Form.useForm();
  // const [timeInterview, setTimeInterview] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isEditNote, setIsEditNote] = useState(false);

  const handleCancelAddInterview = () => {
    setIsModalAddInterview(false);
  };

  const handleChangeDate = (date) => {
    setSelectedDate(date);
  };

  const handleChangeTimeStart = (value) => {
    // setTimeInterview(value);
    form.setFieldsValue({ time_start: value });
  };
  const handleChangeTimeEnd = (value) => {
    // setTimeInterview(value);
    form.setFieldsValue({ time_end: value });
  };

  useEffect(() => {
    form.resetFields();
    if (dateTimeSelect != null) {
      if (typeModal == "add") {
        form.setFieldsValue({
          start_date: moment(dateTimeSelect.dateStr),
          time_start: moment(dateTimeSelect.dateStr),
          time_end: moment(dateTimeSelect.dateStr).add(5, "minutes"),
        });
      } else {
        // Modal view
        let data_schedule = dateTimeSelect.event.extendedProps;
        if (["", null].includes(data_schedule.note) == false) {
          // TH có note
          dateTimeSelect["note_date"] = moment(data_schedule.note_date).format(
            "DD/MM/YYYY HH:mm:ss"
          );
          setIsEditNote(true);
        } else {
          setIsEditNote(false);
        }
        let ls_user_interview =
          data_schedule.user_interview != null
            ? data_schedule.user_interview.split(",")
            : undefined;
        if (ls_user_interview != undefined) {
          ls_user_interview = ls_user_interview.map(Number);
        }
        form.setFieldsValue({
          start_date: moment(data_schedule.start_date),
          time_start: moment(
            `${data_schedule.start_date}T${data_schedule.time_start}`
          ),
          time_end: moment(
            `${data_schedule.start_date}T${data_schedule.time_end}`
          ),
          title: data_schedule.title_interview,
          user_interview: ls_user_interview,
          note: data_schedule.note,
        });
      }
      setSelectedDate(moment(dateTimeSelect.dateStr));
    }
  }, [isModalAddInterview]);

  return (
    <ModalAddInterview
      form={form}
      isModalAddInterview={isModalAddInterview}
      handleCancelAddInterview={handleCancelAddInterview}
      handleChangeTimeStart={handleChangeTimeStart}
      handleChangeTimeEnd={handleChangeTimeEnd}
      // timeInterview={timeInterview}
      onFinishAddInterview={onFinishAddInterview}
      handleChangeDate={handleChangeDate}
      selectedDate={selectedDate}
      typeModal={typeModal}
      onFinishDelete={onFinishDelete}
      dateTimeSelect={dateTimeSelect}
      isEditNote={isEditNote}
      onFinishEdit={onFinishEdit}
      listUser={listUser}
      handleViewCVInterview={handleViewCVInterview}
    />
  );
};

export default index;
